(() => {
  if (window.__productLinkedSwatchesPdpLoaded) return;
  window.__productLinkedSwatchesPdpLoaded = true;

  const SELECTOR_ROOT = '#color-select';
  const SELECTOR_LIST = '#color-select .option-values';
  const MAX_INIT_ATTEMPTS = 60;

  const escapeHtml = (value) => {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  const normalize = (value) => {
    return String(value || '').trim().toLowerCase();
  };

  const getColorBackground = (
    colors,
    style = 'line'
  ) => {
    if (!Array.isArray(colors) || !colors.length) {
      return '#f3f3f3';
    }

    if (colors.length === 1) {
      return colors[0];
    }

    const segmentSize = 100 / colors.length;

    const stops = colors.flatMap(
      (color, index) => {
        const start = segmentSize * index;
        const end = segmentSize * (index + 1);

        return [
          `${color} ${start}%`,
          `${color} ${end}%`
        ];
      }
    );

    if (style === 'conic') {
      return `conic-gradient(from -90deg, ${stops.join(', ')})`;
    }

    return colors[0];
  };

  const renderSwatchHtml = (swatch) => {
    if (!swatch) return '';

    if (swatch.image) {
      return `
        <span
          class="
            product-form__swatch
            product-form__swatch--image
          "
          aria-hidden="true"
        >
          <img
            src="${escapeHtml(swatch.image)}"
            alt=""
            width="48"
            height="48"
            loading="lazy"
          >
        </span>
      `;
    }

    if (
      swatch.style === 'conic' &&
      Array.isArray(swatch.colors) &&
      swatch.colors.length
    ) {
      return `
        <span
          class="
            product-form__swatch
            product-form__swatch--color
            product-form__swatch--conic
          "
          style="
            --swatch-background:
            ${escapeHtml(
              getColorBackground(
                swatch.colors,
                swatch.style
              )
            )};
          "
          aria-hidden="true"
        ></span>
      `;
    }

    const segments = (swatch.colors || [])
      .map(
        (color) => `
          <span
            class="product-form__swatch-segment"
            style="background: ${escapeHtml(color)};"
          ></span>
        `
      )
      .join('');

    return `
      <span
        class="
          product-form__swatch
          product-form__swatch--color
          product-form__swatch--line
        "
        aria-hidden="true"
      >
        ${segments}
      </span>
    `;
  };

  const mergeVendorGroups = (groups) => {
    const vendorGroups = (groups || []).filter(
      (group) =>
        group.valueSource === 'vendor'
    );

    if (!vendorGroups.length) {
      return null;
    }

    const merged = {
      ...vendorGroups[0],
      valueSource: 'vendor',
      swatches: []
    };

    const swatchesByLabel = new Map();

    vendorGroups.forEach((group) => {
      (group.swatches || []).forEach((swatch) => {
        swatchesByLabel.set(
          normalize(swatch.label),
          swatch
        );
      });
    });

    merged.swatches = [
      ...swatchesByLabel.values()
    ];

    return merged;
  };

  const getCurrentProductContext = () => {
    const section = document.querySelector(
      '[data-product-variant-swatches]'
    );

    if (!section) return null;

    const id = String(
      section.getAttribute('data-product-id') || ''
    ).trim();

    const handle = String(
      section.getAttribute('data-product-handle') || ''
    ).trim();

    const title = String(
      section.getAttribute('data-product-title') || ''
    ).trim();

    const vendor = String(
      section.getAttribute('data-product-vendor') || ''
    ).trim();

    if (!title) return null;

    return {
      id,
      handle,
      title,
      vendor
    };
  };

  const isCurrentProduct = (
    product,
    current
  ) => {
    if (!product || !current) return false;

    if (
      current.id &&
      String(product.id) === String(current.id)
    ) {
      return true;
    }

    if (
      current.handle &&
      normalize(product.handle) ===
        normalize(current.handle)
    ) {
      return true;
    }

    return (
      normalize(product.vendor) ===
      normalize(current.vendor)
    );
  };

  const getRenderablePartners = (
    partners,
    group,
    current
  ) => {
    const configured = (partners || [])
      .map((product) => {
        const swatch =
          window.ProductSwatches
            .getSwatchForValue(
              group,
              product.vendor
            );

        if (!swatch) return null;

        return {
  product,
  swatch,
  active: isCurrentProduct(
    product,
    current
  ),
  soldOut: !product.available
};
      })
      .filter(Boolean);

    configured.sort((a, b) => {
      if (a.active && !b.active) return -1;
      if (!a.active && b.active) return 1;
      return 0;
    });

    return configured;
  };

  const ensurePreview = () => {
    let preview = document.querySelector(
      '[data-product-linked-swatch-preview]'
    );

    if (preview) return preview;

    preview = document.createElement('div');
    preview.className =
      'product-variant-swatch-preview';

    preview.setAttribute(
      'data-product-linked-swatch-preview',
      ''
    );

    preview.innerHTML = `
      <div
        class="product-variant-swatch-preview__visual"
        data-preview-visual
      ></div>
      <div
        class="product-variant-swatch-preview__label"
        data-preview-label
      ></div>
    `;

    document.body.appendChild(preview);

    return preview;
  };

  const renderPreviewVisual = (
    preview,
    visual
  ) => {
    const visualEl = preview.querySelector(
      '[data-preview-visual]'
    );

    if (!visualEl) return false;

    visualEl.classList.remove('is-visible');
    visualEl.innerHTML = '';
    visualEl.style.removeProperty(
      '--preview-swatch-background'
    );

    if (!visual) return false;

    if (
      visual.type === 'image' &&
      visual.image
    ) {
      visualEl.innerHTML = `
        <img
          class="product-variant-swatch-preview__image"
          src="${escapeHtml(visual.image)}"
          alt=""
        >
      `;

      visualEl.classList.add('is-visible');
      return true;
    }

    if (
      visual.type === 'swatch' &&
      Array.isArray(visual.colors) &&
      visual.colors.length
    ) {
      if (visual.style === 'conic') {
        visualEl.innerHTML = `
          <div
            class="product-variant-swatch-preview__swatch"
            style="
              --preview-swatch-background:
              ${escapeHtml(
                getColorBackground(
                  visual.colors,
                  visual.style
                )
              )};
            "
          ></div>
        `;
      } else {
        const segments = visual.colors
          .map(
            (color) => `
              <span
                class="product-form__swatch-segment"
                style="background: ${escapeHtml(color)};"
              ></span>
            `
          )
          .join('');

        visualEl.innerHTML = `
          <div
            class="product-variant-swatch-preview__swatch"
          >
            ${segments}
          </div>
        `;
      }

      visualEl.classList.add('is-visible');
      return true;
    }

    return false;
  };

  const showPreview = (
    anchor,
    item,
    group
  ) => {
    if (
      !group.rolloverPreview &&
      !group.labelPopup &&
      !group.swatchPreview
    ) {
      return;
    }

    const preview = ensurePreview();

    const labelEl = preview.querySelector(
      '[data-preview-label]'
    );

    let visual = null;

    if (
      group.swatchPreview &&
      item.swatch
    ) {
      if (item.swatch.image) {
        visual = {
          type: 'image',
          image: item.swatch.image
        };
      } else if (
        item.swatch.colors &&
        item.swatch.colors.length
      ) {
        visual = {
          type: 'swatch',
          colors: item.swatch.colors,
          style: item.swatch.style
        };
      }
    } else if (
      group.rolloverPreview &&
      item.product.image
    ) {
      visual = {
        type: 'image',
        image: item.product.image
      };
    }

    const hasVisual =
      renderPreviewVisual(
        preview,
        visual
      );

    if (labelEl) {
      if (group.labelPopup) {
        labelEl.textContent =
          item.product.vendor;

        labelEl.classList.add(
          'is-visible'
        );
      } else {
        labelEl.textContent = '';
        labelEl.classList.remove(
          'is-visible'
        );
      }
    }

    if (
      !hasVisual &&
      !group.labelPopup
    ) {
      return;
    }

    preview.style.transform =
      'translate3d(0, 0, 0)';

    const rect =
      anchor.getBoundingClientRect();

    const previewWidth =
      preview.offsetWidth || 120;

    const previewHeight =
      preview.offsetHeight || 120;

    const gap = 12;

    let left =
      rect.left +
      rect.width / 2 -
      previewWidth / 2;

    let top =
      rect.top -
      previewHeight -
      gap;

    left = Math.max(
      8,
      Math.min(
        left,
        window.innerWidth -
          previewWidth -
          8
      )
    );

    if (top < 8) {
      top = rect.bottom + gap;

      preview.classList.add(
        'is-below'
      );
    } else {
      preview.classList.remove(
        'is-below'
      );
    }

    preview.style.transform = `
      translate3d(
        ${Math.round(left)}px,
        ${Math.round(top)}px,
        0
      )
    `;

    preview.classList.add(
      'is-visible'
    );
  };

  const hidePreview = () => {
    const preview = document.querySelector(
      '[data-product-linked-swatch-preview]'
    );

    if (!preview) return;

    preview.classList.remove(
      'is-visible'
    );

    preview.style.transform =
      'translate3d(-9999px, -9999px, 0)';
  };

  const render = (
    list,
    root,
    items,
    group
  ) => {
    if (!items.length) {
      list.innerHTML = '';
      root.hidden = true;
      root.classList.remove('is-loading');
      return;
    }

    root.hidden = false;

    list.style.setProperty(
      '--product-swatch-size',
      `${group.productSwatchSize}px`
    );

    list.innerHTML = items
      .map(({ product, swatch, active, soldOut }) => {
        const vendor = escapeHtml(
          product.vendor
        );

        return `
          <a
            href="${escapeHtml(product.url)}"
            class="
  linked-product-swatch
  ${active ? 'is-active' : ''}
  ${soldOut ? 'is-soldout' : ''}
"
            data-linked-product-swatch
            data-product-id="${escapeHtml(product.id)}"
            data-product-handle="${escapeHtml(product.handle)}"
            data-product-vendor="${vendor}"
            data-soldout="${soldOut ? 'true' : 'false'}"
            aria-label="${vendor}"
            title="${vendor}"
            ${active ? 'aria-current="page"' : ''}
          >
            ${renderSwatchHtml(swatch)}
            <span class="visually-hidden">
              ${vendor}
            </span>
          </a>
        `;
      })
      .join('');

    list
      .querySelectorAll(
        '[data-linked-product-swatch]'
      )
      .forEach((anchor, index) => {
        const item = items[index];

        anchor.addEventListener(
          'mouseenter',
          () => {
            showPreview(
              anchor,
              item,
              group
            );
          }
        );

        anchor.addEventListener(
          'mouseleave',
          hidePreview
        );

        anchor.addEventListener(
          'focus',
          () => {
            showPreview(
              anchor,
              item,
              group
            );
          }
        );

        anchor.addEventListener(
          'blur',
          hidePreview
        );
      });

    root.classList.remove(
      'is-loading'
    );
  };

  const initPdp = async () => {
    if (!window.ProductSwatches) {
      return false;
    }

    const root =
      document.querySelector(
        SELECTOR_ROOT
      );

    const list =
      document.querySelector(
        SELECTOR_LIST
      );

    const current =
      getCurrentProductContext();

    if (!root || !list || !current) {
      return false;
    }

    if (
      root.dataset.productLinkedSwatchesReady ===
      'true'
    ) {
      return true;
    }

    root.dataset.productLinkedSwatchesReady =
      'loading';

    root.classList.add('is-loading');

    const groups =
      window.ProductSwatches
        .getConfiguredGroups({
          productId: current.id,
          productHandle: current.handle
        });

    const group =
      mergeVendorGroups(groups);

    if (!group) {
      root.hidden = true;
      root.classList.remove('is-loading');
      root.dataset.productLinkedSwatchesReady =
        'true';
      return true;
    }

    try {
      const partners =
        await window.ProductSwatches
          .getPartnerProducts(
            current.title
          );

      const items =
        getRenderablePartners(
          partners,
          group,
          current
        );

      render(
        list,
        root,
        items,
        group
      );

      root.dataset.productLinkedSwatchesReady =
        'true';

      return true;
    } catch (error) {
      console.error(
        'Product linked swatches failed to load:',
        error
      );

      root.classList.remove('is-loading');
      root.dataset.productLinkedSwatchesReady =
        'error';

      return false;
    }
  };

  const boot = () => {
    let attempts = 0;

    const tryInit = () => {
      attempts += 1;

      Promise.resolve(initPdp()).then(
        (initialized) => {
          if (
            initialized ||
            attempts >= MAX_INIT_ATTEMPTS
          ) {
            return;
          }

          window.setTimeout(
            tryInit,
            50
          );
        }
      );
    };

    tryInit();
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      { once: true }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    () => {
      const root =
        document.querySelector(
          SELECTOR_ROOT
        );

      if (root) {
        delete root.dataset
          .productLinkedSwatchesReady;
      }

      boot();
    }
  );
})();
